import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const getPromotions = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/promotions`, { ...withAuth(), params })).data;

export const getPromotionById = async (branchId, id) =>
  (await axios.get(`${API_URL}/branch/${branchId}/promotions/${id}`, withAuth())).data;

export const createPromotion = async (branchId, data) =>
  (await axios.post(`${API_URL}/branch/${branchId}/promotions`, data, withAuth())).data;

export const updatePromotion = async (branchId, id, data) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/promotions/${id}`, data, withAuth())).data;

export const deletePromotion = async (branchId, id) =>
  (await axios.delete(`${API_URL}/branch/${branchId}/promotions/${id}`, withAuth())).data;
